import React from "react";
import Introduction from "../../components/introduction/Introduction";

import "./about.css";
export default function About() {
  return (
    <div className="aboutPage">
      <div className="aboutContainer">
        <Introduction />
      </div>
    </div>
  );
}
